import styled from 'styled-components';

const LinearGradientDivider = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, var(--line-gray) 0%, var(--background-gray-light));
`;

export default LinearGradientDivider;
